import { ePageBaseStatus } from "../../../models/ePageBaseStatus";
import { ICrmHocSinhActionTypes } from "../../action-types/crm-hocsinh/ICrmHocSinhActionTypes";
import { ICrmHocSinhReducer } from "../../page-state-model/crm-hocsinh/ICrmHocSinhReducer";

const iniState: ICrmHocSinhReducer = {
    status: ePageBaseStatus.is_not_initialization,
    hocSinhs: [],
    hocSinhSelectedIds: []
};

export const crmHocSinhReducer = (state: ICrmHocSinhReducer = iniState, action: ICrmHocSinhActionTypes): ICrmHocSinhReducer => {
    switch (action.type) {
        case "CRM_HOC_SINH_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            };
        case "CRM_HOC_SINH_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhs: action.payload
            };
        case "CRM_HOC_SINH_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                hocSinhs: []
            };
        case "CRM_HOC_SINH_CHANGE_SELECTED_IDS":
            return {
                ...state,
                hocSinhSelectedIds: action.payload
            };
        default:
            return state;
    }
};
